import { GraphToggle } from "@/components/GraphToggle";
import { RoundButtonWithToggleIcon } from "@/components/tools/RoundButtonWithToggleIcon";
import { useEstateContext } from "@/context/EstateContext";
import { useLanguage } from "@/context/LanguageContext";
import { useWatchDogContext } from "@/context/WatchDogContext";
import React from "react";
import { RoundButtonsContainer } from "@/components/tools/RoundButtonsContainer";
import { CalendarDaysIcon, CalendarIcon } from "@heroicons/react/24/outline";

type MyEstateSorterProps = {
  children?: React.ReactNode;
  showPredictionToggle?: boolean;
};

export const MyEstateSorter: React.FC<MyEstateSorterProps> = ({
  children,
  showPredictionToggle = true,
}) => {
  const { language } = useLanguage();
  const copy = {
    cs: {
      showCurrent: "Zobrazit aktuální",
      showPrediction: "Zobrazit predikci",
    },
    en: {
      showCurrent: "Show current",
      showPrediction: "Show forecast",
    },
  }[language];
  const { userInfoGlobal } = useWatchDogContext();
  const { isPredictionView, setIsPredictionView, isGraphView, setIsGraphView } =
    useEstateContext();

  return (
    <RoundButtonsContainer>
      {children}
      {showPredictionToggle ? (
        <RoundButtonWithToggleIcon
          icon={isPredictionView ? CalendarIcon : CalendarDaysIcon}
          isActive={isPredictionView}
          onClick={() => setIsPredictionView((prev) => !prev)}
          tooltipTextActive={copy.showCurrent}
          tooltipTextInactive={copy.showPrediction}
          activeClassName="text-softiq-secondary"
        />
      ) : null}
      <GraphToggle
        isGraphView={isGraphView}
        setIsGraphView={setIsGraphView}
        showHint={false}
        disabled={
          userInfoGlobal?.membership !== "PROFESSIONAL" &&
          userInfoGlobal?.membership !== "BASIC"
        }
      />
    </RoundButtonsContainer>
  );
};
